const activateElement = (element) => {
    element.classList.remove('d-none');

    element.querySelectorAll('input, select, textarea').forEach((el) => {
        el.disabled = false;
    });
};

const disactivateElement = (element) => {
    element.classList.add('d-none');

    element.querySelectorAll('input, select, textarea').forEach((el) => {
        el.disabled = true;
    });
};

export const selectShowAdditionalContentListener = () => {
    const selectElements = [
        ...document.querySelectorAll('.js-select-show-additional-content'),
    ].filter((el) => !el.dataset.otherFieldInitialized);

    selectElements.forEach((selectElement) => {
        const additionalElements = [...selectElement.options]
            .filter((optionElement) => optionElement.dataset.showAdditionalContent)
            .reduce(
                (memo, optionElement) => [
                    ...memo,
                    ...[...document.querySelectorAll(optionElement.dataset.showAdditionalContent)],
                ],
                []
            );

        additionalElements.forEach((el) => {
            disactivateElement(el);
        });

        selectElement.addEventListener('change', () => {
            const selectedOption = selectElement.options[selectElement.selectedIndex];

            additionalElements.forEach((el) => {
                disactivateElement(el);
            });

            if (selectedOption.dataset.showAdditionalContent) {
                const additionalContentElements = document.querySelectorAll(
                    selectedOption.dataset.showAdditionalContent
                );

                additionalContentElements.forEach((el) => {
                    activateElement(el);
                });
            }
        });

        selectElement.dataset.otherFieldInitialized = true;
    });
};
